import React from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";

const center = { lat: 36.7783, lng: -119.4179 };

export const properties = [
  {
    id: "km-los-angeles",
    name: "Kidder Mathews - Los Angeles",
    position: { lat: 34.046438, lng: -118.255459 }
  },
  {
    id: "km-el-segundo",
    name: "Kidder Mathews - El Segundo",
    position: { lat: 33.916923, lng: -118.394389 }
  },
  {
    id: "km-orange-county",
    name: "Kidder Mathews - Orange County",
    position: { lat: 33.701919, lng: -117.884850 }
  },
  {
    id: "km-inland-empire",
    name: "Kidder Mathews - Inland Empire (Ontario)",
    position: { lat: 34.070015, lng: -117.575844 }
  },
  {
    id: "km-roseville",
    name: "Kidder Mathews - Roseville (Sacramento)",
    position: { lat: 38.771038, lng: -121.265717 }
  },
  {
    id: "km-san-diego",
    name: "Kidder Mathews - San Diego",
    position: { lat: 32.779167, lng: -117.132624 }
  },
  {
    id: "km-san-francisco",
    name: "Kidder Mathews - San Francisco",
    position: { lat: 37.792944, lng: -122.398271 }
  },
  {
    id: "km-silicon-valley",
    name: "Kidder Mathews - Silicon Valley (Redwood Shores)",
    position: { lat: 37.518641, lng: -122.254089 }
  }
];


// highlight selected properties
const highlighted = ["kidder-mathews-la", "kidder-mathews-sf"];

function createSvgDataUrl(color: string, label?: string, glow?: boolean) {
    const outline = glow ? "yellow" : "white";
    const svg = `
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'>
        <circle cx='24' cy='18' r='14' fill='${color}' stroke='${outline}' stroke-width='3'/>
        <text x='24' y='22' text-anchor='middle' alignment-baseline='middle'
          fill='white' font-size='12' font-weight='bold'>${label || ""}</text>
      </svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export const ApstMapping: React.FC = () => {
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}>
      <Map defaultCenter={center} defaultZoom={6} style={{ width: "100%", height: "100%" }}>
        {/* {properties.map((m) => {
          const isHL = highlighted.includes(m.id);
          return (
            <Marker
              key={m.id}
              position={m.position}
              icon={{
                url: createSvgDataUrl(isHL ? "#FFB300" : 'red', 'blue', isHL),
                scaledSize: new Size(isHL ? 50 : 36, isHL ? 50 : 36),
              }}
            />
          );
        })} */}
      </Map>
    </APIProvider>
  );
};
